import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  createStyles,
  FileButton,
  Flex,
  Group,
  Loader,
  Skeleton,
  Text,
} from "@mantine/core";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { useSelector } from "react-redux";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useForm } from "@mantine/form";
import swal from "sweetalert";
import { decrypt, encrypt, showError } from "../../../utils";

import {
  addStaff,
  addStaffSkypoint,
  editStaff,
  editStaffSkypoint,
  getStaffById,
  getStaffByIdSkypoint,
  getAllStaffSkypoint,
} from "../../../services/staff";
import TableLoader from "../../../components/TableLoader";
import { uploadFileToS3Api } from "../../../utils/PresignedUrlFunction";
import { SkypointStaffDetailsTab } from "../../../components/SkypointStaffDetails/SkypointStaffDetailsTab";
import { SkypointStaffRolePermissionTab } from "../../../components/SkypointStaffDetails/SkypointStaffRolePermissionTab";
import { SkypointStaffDocumentsTab } from "../../../components/SkypointStaffDetails/SkypointStaffDocumentsTab";
import { SkypointStaffSettings } from "../../../components/SkypointStaffDetails/SkypointStaffSettings";
import SkypointUploadStaffDoc from "../../../components/SkypointStaffDetails/SkypointUploadStaffDoc";
import { getAllSkypointProvider } from "../../../services/skypointProvider";

const useStyles = createStyles((theme) => ({
  content: {
    display: "flex",
    width: "100%",
    height: "100%",
    minHeight: "100vh",
    flexDirection: "column",
    overflowX: "auto",
    backgroundColor: "#F5F5F5",
  },
  staffInfoContainer: {
    borderRadius: "10px",
    backgroundColor: "#FCFCFC",
    margin: "20px",
  },
  staffDetails: {
    display: "flex",
    alignItems: "center",
    padding: "20px",
    gap: "20px",
  },
  tabContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    gap: "20px",
    padding: "0 20px",
  },
  tab: {
    padding: "10px 0",
    cursor: "pointer",
    borderBottom: "2px solid transparent",
    transition: "all 0.2s ease",
    color: "#262626",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    textTransform: "capitalize",
  },
  activeTab: {
    fontWeight: 700,
    color: "#000",
    borderBottom: "2px solid #000",
  },
  disabledTab: {
    pointerEvents: "none",
    opacity: 0.5,
    cursor: "not-allowed",
    color: "#262626",
  },
  title: {
    margin: "0 20px",
    color: "#171717",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    marginTop: "15px",
  },
}));
const SkypointStaffDetails = () => {
  const { id, mode } = useParams(); // mode can be "view" or "edit"
  const { loading, staff } = useSelector((state) => state.staff);
  const [selectedStaff, setSelectedStaff] = useState(
    staff?.staffs?.find((s) => String(s.id) === String(id))
  );
  const { profile } = useSelector((state) => state?.profile);
  const { classes, cx } = useStyles();
  const navigate = useNavigate();

  const tabs = ["details", "roles and permissions", "settings", "documents"];
  const [activeTab, setActiveTab] = useState("details");
  const openRef = useRef();
  const [image, setImage] = useState(null);
  const [imageloading, setImageLoading] = useState(false);
  const [returnedId, setReturnedId] = useState();
  const [alreadyCreatedStaff, setAlreadyCreatedStaff] = useState(null);
  const edit = selectedStaff ? true : false;

  const location = useLocation();
  let notificationDoc = location.state?.notificationDoc;

  useEffect(() => {
    if (notificationDoc) {
      setSelectedStaff(notificationDoc?.staff);
    }
  }, []);

  useEffect(() => {
    setAlreadyCreatedStaff(null);
    getAllSkypointProvider("all");
    if (!edit) getAllStaffSkypoint(1, false, undefined, "");
  }, []);

  useEffect(() => {
    if (edit == true) {
      getStaffByIdSkypoint(staffResponse?.id || selectedStaff?.id);
    }
  }, []);

  useEffect(() => {
    if (selectedStaff?.photo && !image) {
      setImage(selectedStaff?.photo);
    }
  }, [selectedStaff]);

  useEffect(() => {
    if (notificationDoc) {
      setActiveTab("documents");
    }
  }, [notificationDoc, location]);

  const form = useForm({
    mode: "uncontrolled",

    initialValues: {
      fullName: edit ? selectedStaff?.name : "",
      firstName: edit
        ? selectedStaff?.firstName?.split(" ")?.[0] ||
          selectedStaff?.name?.split(" ")?.[0]
        : "",
      lastName: edit
        ? selectedStaff?.lastName ||
          selectedStaff?.firstName?.split(" ")?.slice(1).join(" ") ||
          selectedStaff?.name?.split(" ")?.slice(1).join(" ") ||
          ""
        : "",

      position: edit ? selectedStaff?.position : "",
      email: edit ? selectedStaff?.email : "",
      phone: edit
        ? selectedStaff?.phone
          ? Number(selectedStaff.phone)
          : ""
        : "",
      role: edit ? selectedStaff?.role : "",
      providerId: edit ? selectedStaff?.providerId?.map((f) => f?.id) : [],
      is2FaAccess: edit ? selectedStaff?.is2FaAccess : false,
    },

    validate: {
      firstName: (value) => (value?.trim() ? null : "Required"),
      lastName: (value) => (value?.trim() ? null : "Required"),
      position: (value) => (value?.trim() ? null : "Required"),
      // role: (value) => (value ? null : "Required"),
      // facilityId: (value) => (addedFacilities.length > 0 ? null : "Required"),
      // phone: (value) => (value ? null : "Required"),
      email: (value) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(value?.trim() ?? "")
          ? null
          : "Please enter a valid email address";
      },
    },
  });

  const [addedProviders, setAddedProviders] = useState(
    selectedStaff?.providerId?.map((f) => ({
      value: f.id,
      label: f.name,
    })) || []
  );

  const [role, setRole] = useState("staff");
  const [staffResponse, setStaffResponse] = useState();
  const [roleError, setRoleError] = useState(false);

  const handleSave = async (values) => {
    // Strip accidental leading/trailing spaces from every text field
    const trimmedValues = Object.fromEntries(
      Object.entries(form.values).map(([key, val]) => [
        key,
        typeof val === "string" ? val.trim() : val,
      ])
    );
    let payload = {
      ...trimmedValues,
      providerId: addedProviders?.map((i) => i?.value),
      role,
      photo: image,
      // fullName: `${form.values.firstName} ${form.values.lastName}`,
    };
    if (activeTab === "details") {
      const validation = form.validate();
      if (!validation.hasErrors) {
        setActiveTab("roles and permissions");
      }
    } else if (activeTab === "roles and permissions") {
      if (role) {
        setRoleError(false);
        setActiveTab("settings");
      } else {
        setRoleError(true);
      }
    } else if (activeTab === "settings") {
      if (mode === "edit" || alreadyCreatedStaff) {
        payload = {
          ...payload,
          name: `${trimmedValues.firstName} ${trimmedValues.lastName}`,
          id,
        };
        let response = await editStaffSkypoint(payload, true, activeTab);
        if (response) {
          handleCancel();
        }
      } else {
        payload = {
          ...payload,
          fullName: `${trimmedValues.firstName} ${trimmedValues.lastName}`,
          active: false,
          signatureActive: false,
        };
        let response = await addStaffSkypoint(payload, activeTab);
        // This email belongs to a staff member who was removed earlier — confirm
        // before reactivating their old account.
        if (response?.previouslyRemoved) {
          const willRestore = await swal({
            title: "Restore removed staff?",
            text: response?.message,
            icon: "warning",
            buttons: ["Cancel", "Restore & Resend Invite"],
          });
          if (!willRestore) return;
          response = await addStaffSkypoint(
            { ...payload, restore: true },
            activeTab
          );
        }
        if (response?.staff) {
          setReturnedId(response?.staff);
          setAlreadyCreatedStaff(response?.staff);
          handleCancel();
        }
      }
    }
  };
  const handleCancel = () => {
    navigate("/home/staff-skypoint");
    form.reset();
    setAddedProviders(selectedStaff?.providerId || []);
  };

  // // Function to handle image upload and processing
  // const onChangePhoto = async (files) => {
  //   setImageLoading(true);
  //   if (files) {
  //     const formData = new FormData();
  //     formData.append("file", files);
  //     const localImageUrl = await uploadStaffProfile(formData); // Generate blob URL
  //     const encryptedImageUrl = encrypt(localImageUrl?.imageUrl); // If needed
  //     setImage(encryptedImageUrl);
  //     setImageLoading(false);
  //   }
  //   if (openRef.current) {
  //     openRef.current();
  //   }
  // };

  const onChangePhoto = async (files) => {
    if (!files) return;
    try {
      setImageLoading(true);

      // 1. Upload to S3
      const result = await uploadFileToS3Api({ file: files });

      // 2. Encrypt the image URL (if needed)
      const encryptedImageUrl = encrypt(result?.uploadURL);

      // 3. Update UI with image
      setImage(encryptedImageUrl);

      // 4. Trigger modal or UI action
      if (openRef.current) {
        openRef.current();
      }
    } catch (error) {
      console.error("Upload failed", error);
      showError(error?.message || "Upload failed");
    } finally {
      setImageLoading(false);
    }
  };

  return (
    <Box fluid className={classes.content}>
      <AppNavbar title={`${mode} Staff`} profile={profile} />
      <Flex
        align="center"
        gap={5}
        m={10}
        onClick={() => navigate("/home/staff-skypoint")}
        style={{ cursor: "pointer", width: "fit-content" }}
      >
        <MdKeyboardArrowLeft size={30} />
        <Text fw={400} fz={14} c={"#262626"} ff={"Inter"}>
          Back
        </Text>
      </Flex>
      <Box className={classes.staffInfoContainer}>
        {loading ? (
          <Skeleton
            height={60}
            radius="sm"
            style={{ margin: "10px", width: "200px" }}
          />
        ) : (
          <Box className={classes.staffDetails}>
            {imageloading ? (
              <Loader size="md" radius="100%" color="yellow" />
            ) : (
              <Avatar
                src={decrypt(image)}
                size={50}
                radius={50}
                shape="circle"
              />
            )}
            {mode !== "view" && (
              <Group>
                <FileButton
                  onChange={(files) => onChangePhoto(files)}
                  openRef={openRef}
                  accept="image/*"
                >
                  {(props) => (
                    <Button
                      variant="filled"
                      color="gray"
                      size="xs"
                      radius="md"
                      {...props}
                    >
                      {edit ? "Change Photo" : "Add Photo"}
                    </Button>
                  )}
                </FileButton>
              </Group>
            )}
            {mode === "add" && (
              <Box className={classes.staffInfo}>
                <Text variant="text" c={"#737373"} fw={400} fz={12}>
                  Staff name
                </Text>
                <Text variant="text" fz={16} fw={600} ff={"Inter"}>
                  {`${form.getTransformedValues()?.firstName} ${
                    form.getTransformedValues()?.lastName
                  }`}
                </Text>
                <Text
                  variant="text"
                  fz={14}
                  fw={500}
                  c={"#737373"}
                  ff={"Inter"}
                  transform={"uppercase"}
                >
                  {selectedStaff?.id?.slice(0, 6)}
                </Text>
              </Box>
            )}
            {mode !== "add" && (
              <Box className={classes.staffInfo}>
                <Text variant="text" c={"#737373"} fw={400} fz={12}>
                  Staff name
                </Text>
                <Text variant="text" fz={16} fw={600} ff="Inter">
                  {selectedStaff?.firstName && selectedStaff?.lastName
                    ? `${selectedStaff.firstName} ${selectedStaff.lastName}`
                    : selectedStaff?.name}
                </Text>
                <Text
                  variant="text"
                  fz={14}
                  fw={500}
                  c={"#737373"}
                  ff={"Inter"}
                  transform={"uppercase"}
                >
                  {selectedStaff?.id?.slice(0, 6)}
                </Text>
              </Box>
            )}
          </Box>
        )}

        {/* Custom Tabs */}
        <Box className={classes.tabContainer}>
          {tabs?.map((tab, index) => (
            <Text
              key={tab}
              className={cx(classes.tab, {
                [classes.activeTab]: activeTab === tab,
                [classes.disabledTab]:
                  mode === "add" && index > tabs.indexOf(activeTab),
              })}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </Text>
          ))}
        </Box>
      </Box>
      {/* <Text className={classes.title}>Staff Information</Text> */}

      {/* Tab Content */}
      <Box className={classes.staffInfoContainer}>
        {loading ? (
          <TableLoader />
        ) : (
          <Box px={20} pb={20}>
            {activeTab === "details" && (
              <SkypointStaffDetailsTab
                data={selectedStaff}
                mode={mode}
                form={form}
                setSelectedStaff={setSelectedStaff}
                handleSave={handleSave}
                handleCancel={handleCancel}
              />
            )}
            {activeTab === "roles and permissions" && (
              <SkypointStaffRolePermissionTab
                data={selectedStaff}
                mode={mode}
                role={role}
                setRole={setRole}
                form={form}
                handleSave={handleSave}
                activeTab={activeTab}
                roleError={roleError}
              />
            )}
            {activeTab === "settings" && (
              <SkypointStaffSettings
                data={selectedStaff}
                mode={mode}
                handleCancel={handleCancel}
                staffResponse={returnedId}
                activeTab={activeTab}
                handleSave={handleSave}
                form={form}
                setAddedProviders={setAddedProviders}
                addedProviders={addedProviders}
              />
            )}
            {activeTab === "documents" && (
              <SkypointStaffDocumentsTab
                userId={selectedStaff?.id || returnedId?.id}
                userType="staff"
              />
            )}
          </Box>
        )}
      </Box>
      {activeTab === "documents" && notificationDoc ? (
        <SkypointUploadStaffDoc
          selectedFolder={notificationDoc?.metadata?.folder}
          userId={notificationDoc?.staff?.id}
          userType={notificationDoc?.userType}
          isDocument={true}
          uploadedFiles={notificationDoc?.metadata?.file}
          isnotificationdoc={true}
        />
      ) : null}
    </Box>
  );
};

export default SkypointStaffDetails;
